<template>
  <v-app id="app">

    <div id="main-background-gradient"></div>

    <!--add 'app' to nav-bar if the navbar should be fixed at top of page-->
    <!--<nav-bar></nav-bar>-->

    <!-- Sizes your content based upon application components -->
    <v-content>
      <router-view></router-view>
    </v-content>


    <!--add 'app' to footer if the navbar should be fixed at top of page-->
    <v-footer >
      <div class="footer">Copyright 2020 Espy Analytics, LLC</div>
    </v-footer>
  </v-app>







</template>


<style scoped lang="scss">
  @import 'assets/styles/variables/Variables';

  #app{
    background: none;
  }


  #main-container{
    /*background: none;*/
    padding: 0;
  }


  #main-background-gradient{
    position: fixed;
    height: 100%;
    /*min-height: 1000px;*/
    width: 100%;
    margin: 0;

    //color: $color-white;
    background: $color-app-background;
    z-index: -1;
    /*opacity: 0.5;*/

  }

  .footer{
    text-align: center;
    width:100%;
  }


</style>

<script>
   import navBar from '@/components/navBar.vue'

export default {
  name: 'App',

  components: {
     navBar
  },

  data: () => ({
    //
  }),
   created(){

   }
};
</script>
